import React from 'react';
import { colors } from '../colors';

const Divider = ({
    className,
    ...props
}: HtmlPropsNoRef<HTMLHRElement>): JSX.Element => (
    <hr
        aria-orientation="horizontal"
        css={{
            opacity: 0.6,
            borderColor: colors.grey200,
            borderStyle: 'solid',
            borderTopWidth: '1px',
            width: '100%',
        }}
        className={className}
        {...props}
    />
);

export default Divider;
